const isLoggedIn = () => {
  const token = localStorage.getItem("accessToken");

  if (typeof token === "undefined" || token === null) return false;
  else return true;
};

export { isLoggedIn };
